import { useSelector } from 'react-redux';
import { getPostUrl } from 'app/utils/post';

export const usePostComunity = (post: any): any => {
  const currentCommunity = useSelector((state: any) => state.auth.community);
  const postCommunity = post && post.data && post.data.community;
  const community = postCommunity || currentCommunity;
  return community;
};

export const usePostUrl = (post: any): string | null => {
  const community = usePostComunity(post);
  const parentPost = post.parentPost || post;
  const postUrl = getPostUrl(community, parentPost);
  return postUrl;
};
